// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { lazy } from "react";
import { useSelector } from "react-redux";
import { Navigate, createBrowserRouter, RouterProvider } from "react-router";
import Loadable from "src/layouts/full/shared/loadable/Loadable";
import { RootState } from "src/redux";
import MyUsers from "src/views/my-users";
import Roles from "src/views/roles";
import { PrivateRoute } from "./PrivateRoute";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(lazy(() => import("../layouts/blank/BlankLayout")));
const Dashboard = Loadable(lazy(() => import("../views/dashboards/Dashboard")));
const Login = Loadable(lazy(() => import("../views/auth/login/Login")));
const Register = Loadable(lazy(() => import("../views/auth/register/Register")));
const Error = Loadable(lazy(() => import("../views/auth/error/Error")));
const Template = Loadable(lazy(() => import("../views/template/index")))
const Blogs = Loadable(lazy(() => import("../views/blog/index")))
const Parameter = Loadable(lazy(() => import("../views/parameter")))
const Users = Loadable(lazy(() => import("../views/users")))
const UsersDetails = Loadable(lazy(() => import("../views/users/detail")))
const Verificatons = Loadable(lazy(() => import("../views/verifications/index")))
const News = Loadable(lazy(() => import("../views/news/index")))
const FlagUsers = Loadable(lazy(() => import("../views/flag/index")))
const DeletedAccount = Loadable(lazy(() => import("../views/deleted-account/index")))
const DeactivatedUsers = Loadable(lazy(() => import("../views/deactivated-users/index")))
const Feedback = Loadable(lazy(() => import("../views/feedback/index")))
const Reports = Loadable(lazy(() => import("../views/reports/index")))
const NotificationManagement = Loadable(lazy(() => import("../views/notfication-managemnet/index")))
const Modertion = Loadable(lazy(() => import("../views/moderation")))
const SendNotification = Loadable(lazy(() => import("../views/send-notificaion")))
const SendNotifictionEmail = Loadable(lazy(() => import("../views/send-email")))
const CreditPackage = Loadable(lazy(() => import("../views/credit-package")))
const Transactions = Loadable(lazy(() => import("../views/transactions")))
const Cities = Loadable(lazy(() => import("../views/cities")))
const AppRoutes = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.user);
  const Router = [
    {
      path: "/",
      element: <Navigate to={isAuthenticated ? "/dashboard" : "/login"} />,
    },
    {
      path: "*",
      element: <Navigate to={isAuthenticated ? "/dashboard" : "/login"} />,
    },
    {
      path: "/",
      element: <PrivateRoute><FullLayout /></PrivateRoute>,
      children: [
        { path: "/dashboard", exact: true, element: <Dashboard /> },
        { path: "/template", exact: true, element: <Template /> },
        { path: "/blogs", exact: true, element: <Blogs /> },
        { path: "/notification", exact: true, element: <NotificationManagement /> },
        { path: "/parameter", exact: true, element: <Parameter /> },
        { path: "/users", exact: true, element: <Users /> },
        { path: "/users/detail/:id", exact: true, element: <UsersDetails /> },
        { path: "/my-users", exact: true, element: <MyUsers /> },
        { path: "/verificatons", exact: true, element: <Verificatons /> },
        { path: "/news", exact: true, element: <News /> },
        { path: "/flag", exact: true, element: <FlagUsers /> },
        { path: "/roles", exact: true, element: <Roles /> },
        { path: "/deleted", exact: true, element: <DeletedAccount /> },
        { path: "/deactivated", exact: true, element: <DeactivatedUsers /> },
        { path: "/feedback", exact: true, element: <Feedback /> },
        { path: "/reports", exact: true, element: <Reports /> },
        { path: "/moderation", exact: true, element: <Modertion /> },
        { path: "/sendNotification", exact: true, element: <SendNotification /> },
        { path: "/sendEmail", exact: true, element: <SendNotifictionEmail /> },
        { path: "/credit-package", exact: true, element: <CreditPackage /> },
        { path: "/transactions", exact: true, element: <Transactions /> },
        { path: "/cities", exact: true, element: <Cities /> },
        { path: "*", element: <Navigate to="/auth/404" /> },

      ],
    },
    {
      path: "/",
      element: <BlankLayout />,
      children: [
        { path: "/login", element: <Login /> },
        { path: "/register", element: <Register /> },
        { path: "404", element: <Error /> },
        { path: "/auth/404", element: <Error /> },
        { path: "*", element: <Navigate to="/auth/404" /> },
      ],
    },
  ];

  const router = createBrowserRouter(Router);
  return <RouterProvider router={router} />;
};

export default AppRoutes;
